import * as React from 'react';
import classnames from 'classnames';
import { getPrefixCls } from '@/utils/public';
import './index.less';

interface IProps {
  children: React.ReactNode;
  type?: 'default' | 'primary' | 'link';
  shape?: string;
  gradual?: boolean;
  className?: string;
  id?: string;
  disabled?: boolean;
  onClick?: () => void;
}

const prefixCls = getPrefixCls('btn');

const Button: React.FC<IProps> = (props) => {
  const { children, type = 'default', shape, gradual, className, id = '', disabled = false, onClick } = props;
  const classes = classnames(
    prefixCls,
    {
      [`${prefixCls}-${shape}`]: shape,
      [`${prefixCls}-${type}`]: type,
      [`${prefixCls}-gradual`]: gradual,
      [`${prefixCls}-disabled`]: disabled,
    },
    className,
  );
  return (
    <button className={classes} id={id} disabled={disabled} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
